export enum DocumentType {
  EDUC1 = "educ1",
  EDUC2 = "educ2",
  PROP = "prob",
  JUMP = "jump",
  CERT = "cert",
  OTHER = "other",
}

export const documentTypeTranslations: Record<DocumentType, string> = {
  [DocumentType.CERT]: "Zertifikat",
  [DocumentType.JUMP]: "Zertifikat JUMPStart",
  [DocumentType.PROP]: "Probezeitbericht",
  [DocumentType.EDUC1]: "Bildungsbericht Semester 1",
  [DocumentType.EDUC2]: "Bildungsbericht Semester 2",
  [DocumentType.OTHER]: "Anderes",
};

export function getDocumentTypeOptions() {
  return Object.values(DocumentType).map((value) => ({ value, label: documentTypeTranslations[value] }));
}
